import styles from './PublisherHeader.module.scss'
import BedtimeIcon from '@mui/icons-material/Bedtime'
import BedtimeOutlinedIcon from '@mui/icons-material/BedtimeOutlined'
import Switch from '@mui/material/Switch'
import { useTranslations } from 'next-intl'

interface NightModeSelectProps {
  toggleNightMode: () => void
  selectedTheme: string
}

function NightModeSelect (props: NightModeSelectProps) {
  const t = useTranslations('header')
  return (
    <div
      className={styles.nightModeWrapper}
      onClick={() => props.toggleNightMode()}
    >
      <div className={styles.nightModeFlex}>
        <div
          className={styles.nightModeIcon}
        >
          {props.selectedTheme === 'dark' && <BedtimeIcon />}
          {props.selectedTheme != 'dark' && <BedtimeOutlinedIcon />}
        </div>
        <div style={{ marginRight: '1rem' }}>
          {t('night-mode')}<small style={{ marginLeft: '0.5rem', fontSize: '0.7rem' }}>({t('beta')})</small>
        </div>
        <div className={styles.nightModeToggle} >
          <Switch
            checked={props.selectedTheme === 'dark'}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </div>
      </div>
    </div>
  )
}

export default NightModeSelect
